const PERCENTAGE = 100;
const getSerializedCssSizeValue = (element, prop, { baseFontSize = 16 } = {}) => {
  const style = getComputedStyle(element);
  const value = style.getPropertyValue(prop);
  const isRem = value.includes("rem");
  const isEm = value.includes("em");
  const isPercentage = value.includes("%");
  const isViewportHeight = value.includes("vh");
  const isViewportWidth = value.includes("vw");
  if (isRem || isEm) {
    return Number.parseFloat(value) * baseFontSize;
  }
  if (isPercentage) {
    return Number.parseFloat(value) / PERCENTAGE;
  }
  if (isViewportHeight) {
    return window.innerHeight * Number.parseFloat(value) / PERCENTAGE;
  }
  if (isViewportWidth) {
    return window.innerWidth * Number.parseFloat(value) / PERCENTAGE;
  }
  const result = Number.parseFloat(value);
  if (Number.isNaN(result)) {
    console.error(`Failed to parse value: ${value}`);
    return 0;
  }
  return result;
};

export { getSerializedCssSizeValue };
